import React from "react"
import Link from "next/link"

import { useTranslation, useLanguageQuery } from "next-export-i18n"

const Contact = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()

  return (
    <div className="w-full bg-white ">
      <div className="flex  max-w-7xl mx-auto px-4 py-10 md:py-16">
        <div className="">
          <h2 className="text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3 md:pb-8  text-center  font-semibold   ">
            Your choices
          </h2>
              <p className=" text-base xl:text-xl pb-4  text-center md:text-left font-normal  ">
                You may access and/or request that corrections be made to your
                personal health information. You may also withdraw your consent
                for some of the above uses and disclosures (subject to legal
                obligations) by speaking with your health care provider or
                contacting Carea’s Privacy Officer.
              </p>
          <div className="grid  grid-cols-1 md:grid-cols-2 gap-6 md:gap-24 relative">
            <div className="">
              <h2 className="text-woundTextDark text-base md:text-xl  pb-2 md:pb-3  text-center md:text-left font-semibold   ">
                How to contact us
              </h2>
              <p className=" text-base xl:text-xl pb-3 md:pb-8  text-center md:text-left font-normal  ">
                Contact our Privacy Officer for more information or to share a
                concern at:
              </p>
              <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-semibold  ">
                Privacy Officer, Carea Community Health Centre
              </p>
              <p className=" text-base xl:text-xl   text-center md:text-left font-normal  ">
                115 Grassmere Avenue,
              </p>
              <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-normal  ">
                Oshawa, ON L1H 3X7
              </p>
              <p className=" text-base xl:text-xl  text-center md:text-left font-normal  ">
                Telephone: 905-723-0036
              </p>
              <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-normal  ">
                Email:{" "}
                <a
                  href="mailto:privacyofficer@careachc.ca"
                  target="_blank"
                  className="hover:text-secondary"
                >
                  privacyofficer@careachc.ca
                </a>
              </p>
            </div>
            <div className="">
              <div className="">
                <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-normal  ">
                  You have the right to complain to the Information and Privacy
                  Commissioner/Ontario if you think we have violated your
                  rights. The Commissioner can be reached at:
                </p>
                <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-semibold  ">
                  Information and Privacy Commissioner of Ontario
                </p>
                <p className=" text-base xl:text-xl   text-center md:text-left font-normal  ">
                  2 Bloor Street East, Suite 1400
                </p>
                <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-normal  ">
                  Toronto, ON M4W 1A8
                </p>
                <p className=" text-base xl:text-xl  text-center md:text-left font-normal  ">
                  Telephone: 800-387-0073
                </p>
                <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-normal  ">
                  Fax: 416-325-9195
                </p>
                <p className=" text-base xl:text-xl  text-center md:text-left font-normal  ">
                  Email:{" "}
                  <a
                    href="mailto:info@ipc.on.ca"
                    target="_blank"
                    className="hover:text-secondary"
                  >
                    info@ipc.on.ca
                  </a>
                </p>
                <p className=" text-base xl:text-xl pb-2 md:pb-4  text-center md:text-left font-normal  ">
                  Website:{" "}
                  <a
                    href="https://www.ipc.on.ca"
                    target="_blank"
                    className="hover:text-secondary"
                  >
                    IPC - Information and Privacy Commissioner of Ontario
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
